<template>
	<div class="app-top-bar__right-menu">
		<div v-if="menuIsEnabled" class="d-flex align-center">
			<div class="buttons-setting-container">
				<button @click="toSettings" class="buttons-setting-container__button" type="button">
					<Icon type="note" :size="24" color="var(--accent-color)" />
				</button>
				<button
					class="buttons-setting-container__button"
					type="button"
					@click="toBookmarks"
				>
					<Icon type="bookmark_empty" :size="24" color="var(--accent-color)" />
				</button>
			</div>

			<v-list-item-group
				class="hidden-sm-and-down d-flex"
				active-class="app-top-bar__navigation-active"
				v-ripple="true"
				link
			>
				<v-menu
					left
					close-on-click
					offset-y
					content-class="app-top-bar__profile-menu elevation-0"
				>
					<template v-slot:activator="{ on }">
						<v-btn
							class="app-top-bar__avatar-btn"
							:class="[opacity ? 'app-top-bar__menu-opacity' : '']"
							icon
							v-on="on"
						>
							<v-avatar class="app-top-bar__profile-avatar" :size="40">
								<img
									v-if="userAvatar"
									referrerpolicy="no-referrer"
									:src="userAvatar"
									alt="avatar"
								/>
								<Icon v-else type="profile" color="white" :size="40" />
							</v-avatar>
						</v-btn>
					</template>
					<v-card tile class="elevation-0">
						<v-list-item-content class="justify-center pa-3">
							<v-list-item
								active-class="app-top-bar__active-profile"
								class="app-top-bar__profile-card-item"
								v-for="(setting, index) in profileSettings"
								:key="index"
								@click="setting.action"
								link
								:to="setting.path"
							>
								<Icon :type="setting.name" :size="24" class="mr-2" />
								{{ setting.name }}
							</v-list-item>
						</v-list-item-content>
					</v-card>
				</v-menu>
			</v-list-item-group>
		</div>
		<div v-else class="d-flex flex-nowrap align-center">
			<div class="buttons-setting-container mr-2">
				<button @click="toSettings" class="buttons-setting-container__button" type="button">
					<Icon type="note" :size="24" color="var(--accent-color)" />
				</button>
				<button
					class="buttons-setting-container__button"
					type="button"
					@click="toBookmarks"
				>
					<Icon type="bookmark_empty" :size="24" color="var(--accent-color)" />
				</button>
			</div>
			<router-link :to="{ name: 'profile' }">
				<v-avatar class="app-top-bar__profile-avatar" size="40">
					<img
						v-if="userAvatar"
						referrerpolicy="no-referrer"
						:src="userAvatar"
						alt="avatar"
					/>
					<Icon v-else type="profile" color="white" :size="40" />
				</v-avatar>
			</router-link>
		</div>
	</div>
</template>

<script>
import magnifyIcon from '@/assets/images/search.svg'
import { mapGetters } from 'vuex'

export default {
	name: 'Menu',
	data() {
		return {
			magnifyIconSrc: magnifyIcon,
			searchValue: '',
			expandSearch: false,
			opacity: false,
			avatar: 'https://e7.pngegg.com/pngimages/799/987/png-clipart-computer-icons-avatar-icon-design-avatar-heroes-computer-wallpaper-thumbnail.png',
		}
	},
	watch: {
		$route() {
			this.opacity = this.opacityRoutes.includes(this.$route.name)
		},
	},
	props: {
		opacityRoutes: {
			type: Array,
			default: () => [],
		},
		showOnThisPage: {
			type: Boolean,
			default: false,
		},
		isAuth: {
			type: Boolean,
			default: false,
		},
		profileSettings: {
			type: Array,
			default: () => [],
		},
		categories: {
			type: Array,
			default: () => [],
		},
		navigation: {
			type: Array,
			default: () => [],
		},
		userAvatar: {
			type: String,
			default: null,
		},
	},
	computed: {
		...mapGetters('auth', ['profile']),

		menuIsEnabled() {
			return this.$vuetify.breakpoint.width >= 920
		},
	},
	methods: {
		toSettings() {
			this.$router.push({ name: 'profile-notes' })
		},
		toBookmarks() {
			this.$router.push({ name: 'profile-bookmarks' })
		},
	},
}
</script>

<style lang="scss">
.app-top-bar {
	&__menu-opacity {
		opacity: 0.5;
	}
	&__profile-avatar {
		border-radius: 8px;
	}
	&__profile-menu {
		border: 1px solid #e2e2e2;
	}

	&__search-icon {
		cursor: pointer;
	}

	&__name {
		color: rgb(255, 255, 255);
		font-size: 15px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
	}

	&__search-button {
		background-color: transparent !important;
	}
}

.menu {
	display: flex;
	justify-content: flex-end;
	width: 300px;

	.theme--light.v-list-item:hover::before {
		opacity: 0;
	}

	.theme--light.v-btn:hover::before {
		opacity: 0;
	}

	.v-ripple__container {
		opacity: 0;
	}
}
.buttons-setting-container {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	margin-right: 8px;
	&__button {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 8px;
		width: 40px;
		height: 40px;
		border-radius: 8px;
		border: 1px solid #e2e2e2;
	}
}
</style>
